import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Mr2 } from 'wrappers';
import { Popup, ValueText } from './atoms';
import { SecondaryTextSm400 } from 'atoms';

const template = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  span {
    display: none;
  }
  &:hover {
    span {
      display: unset;
    }
  }
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: wrap(SecondaryTextSm400, Mr2),
      name: 'Label',
      displayValue: ({ label }) => label
    },
    {
      component: ValueText,
      name: 'Value',
      displayValue: ({ value }) => value ?? '',
      displayState: ({ big }) => ({ big })
    },
    {
      component: Popup,
      name: 'Popup',
      displayValue: ({ tooltip }) => tooltip,
      displayState: ({ tooltipPosition }) => ({ direction: tooltipPosition })
    }
  ]
})